export const checkLoadFromModule = (currentState) => {
   const {
      progress: exerciseProgress,
      exerciseDocument,
      levelSelect,
   } = currentState.activeExercise;

   // should not load from aux if they have selected a specific level
   if (levelSelect != null) {
      return false;
   }

   // they are at or above max level for being unsubscribed
   if (exerciseProgress.currentLevel > exerciseDocument.levels.length) {
      return exerciseDocument.levels[exerciseDocument.maxUnpaidLevel]
         ?.loadFromModule;
   }

   return exerciseDocument.levels[exerciseProgress.currentLevel - 1]
      ?.loadFromModule;
};
